import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { parseSi } from '@shell/utils/units';
import { useI18n } from '@shell/composables/useI18n';

interface ClusterRow {
  mgmt?: ClusterRow;
  status?: { allocatable?: { cpu?: string } };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterCpu',
  props: {
    row: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const { t } = useI18n(store);

const cluster = computed(() => props.row?.mgmt || props.row);
const cores = computed(() => parseSi(cluster.value?.status?.allocatable?.cpu));

return (_ctx: any,_cache: any) => {
  return (cores.value)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(`${ cores.value } ${ _unref(t)('landing.clusters.cores', { count: cores.value }) }`), 1))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, "—"))
}
}

})